import { resources } from "@constants/hardcoded-strings";
import { TextareaFormGroup } from "@containers/common/textarea-form-group/textarea-form-group";
import { ThemingFormSection } from "@containers/common/theming-form-section/theming-form-section";
import { MessagingTemplateVariablesFormSection } from "@containers/messaging-template-details/messaging-template-details-component/messaging-template-variables-tab/messaging-template-variables-form-section/messaging-template-variables-form-section"
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";
import styles from './theming-messaging-template-content-form.less';
import commonStyles from "@styles/common.less";
import { ThemingMessagingSelectedTemplateValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";

type ThemingMessagingTemplateContentProps = {
    messagingTemplate: FormattedMessagingTemplate;
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    validationErrors: ThemingMessagingSelectedTemplateValidationErrors;
    selectedLanguage: LocaleTypes;
    setSelectedLanguage: (language: LocaleTypes) => void;
    setMessagingTemplateState: (state: FormattedMessagingTemplate) => void;
}

export const ThemingMessagingTemplateContentForm = (props: ThemingMessagingTemplateContentProps) => {
    const {
        isDisabled,
        messagingTemplate,
        labelWidth,
        validationErrors,
        selectedLanguage,
        setSelectedLanguage,
        setMessagingTemplateState
    } = props;

    const handleUpdateTemplate = (event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedState = {
            ...messagingTemplate,
            template: event.target.value
        };

        setMessagingTemplateState(updatedState);
    }

    const handleResetHtmlTemplate = () => {
        const updatedState = {
            ...messagingTemplate,
            template: messagingTemplate.template
        };

        setMessagingTemplateState(updatedState);
    }

    const handleUpdateMessagingTemplateState = (updatedState: FormattedMessagingTemplate) => {
        setMessagingTemplateState(updatedState);
    }

    const resource = resources.pages.messagingTemplateDetails.tabs.content;
    const messagingTemplateResource = resources.pages.verificationServiceDetails.tabs.theming.subTabs.messaging;

    return <>

        <ThemingFormSection title={resource.sections.template.title}>
            <div className={commonStyles.sectionDescription}>{resource.sections.template.description}</div>
            <TextareaFormGroup
                className={styles.expandedTextArea}
                controlId="messaging-template-template-input"
                automationId="messaging-template-template-input"
                label={resource.inputs.template.label}
                ariaLabel={resource.inputs.template.label}
                placeholder={resource.inputs.template.placeholder}
                value={messagingTemplate.template}
                onChange={handleUpdateTemplate}
                disabled={true}
                isRequired={true}
                labelWidth={labelWidth}
                layout={LayoutTypes.COLUMN}
                afterLabelIcon={null}
                afterLabelIconOnClick={handleResetHtmlTemplate}
                afterLabelTooltipText={messagingTemplateResource.inputs.template.tooltip}
            />
        </ThemingFormSection>

        <MessagingTemplateVariablesFormSection
            isDisabled={isDisabled}
            labelWidth={labelWidth}
            selectedLanguage={selectedLanguage}
            setMessagingTemplateState={handleUpdateMessagingTemplateState}
            setSelectedLanguage={setSelectedLanguage}
            state={messagingTemplate}
            validationErrors={validationErrors.variables}
        />
    </>
}